module.exports = __webpack_public_path__ + "static/media/binance-wallet.745a9935.png";